import type { ComponentType } from "react";
import type { GridRowParams } from "@mui/x-data-grid";
import type { Transaction } from "features/transactions/types";
import TransactionProvider from "./TransactionProvider";

export const withTransaction = (Component: ComponentType) =>
    ({ row }: GridRowParams<Transaction>) => (
        <TransactionProvider
            value={row}
        >
            <Component />
        </TransactionProvider>
    );

export default withTransaction;
